import { BaseHttpService } from './base-http.service'

export default new (class AuthService extends BaseHttpService {
    createComment(path: string, params: any): Promise<any> {
        return super.postPromise(path, params)
    }
})()